<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true">
        {{getCellSummary(dataItem)}}
    </span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-course-single-select-edit-control #editControl (focussed)="columnFocusHandler($event, columnIndex)"
                                           [courseDefinitionId]="courseDefinitionId"
                                           [attr.id]="elementId"
                                           (valueChange)="controlValueChange($event, dataItem, formGroup)"
                                           [formControl]="formGroup.get(valueField)"
                                           [placeholder]="getPlaceholder(dataItem)"
                                           [objectValue]="formGroup.get(field)"
                                           [hideAddOption]="hideAddOption">
    </wbo-course-single-select-edit-control>
</ng-template>
